module.exports = __webpack_public_path__ + "img/paw-search.49fa1ee5.gif";